import { dedicatedService } from "@/common/api.service"
import { dedicatedStatus } from "@/constants/dedicatedStatus"

const initialStates = {
    status: 'loading',
    psp_data_status: 'loading',
    dedicateds: [],
    form_data: {},
    psp_data: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingPspData(state) {
        state.psp_data_status = 'loading'
    },
    success(state, dedicateds) {
        state.status       = 'success'
        state.dedicateds = dedicateds
    },
    fail(state) {
        state.status     = 'fail'
        state.dedicateds = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    setPspData(state, psp_data) {
        state.psp_data_status = 'setPspData'
        state.psp_data = psp_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            if(key == 'sheba') {
                state.form_data[key] = []
            }else {
                state.form_data[key] = ''
            }
        });
    }
}

const getters = {
    status: ({status}) => status,
    psp_data_status: ({psp_data_status}) => psp_data_status,
    gateways: ({dedicateds}) => dedicateds,
    form_data: ({form_data}) => form_data,
    psp_data: ({psp_data}) => psp_data,
    active_gateways: ({dedicateds}) => {
        if(dedicateds.data) {
            return dedicateds.data.filter(dedicated =>
                dedicated.status === dedicatedStatus.ACTIVE
            )
        }

        return dedicateds.filter(dedicated =>
            dedicated.status === dedicatedStatus.ACTIVE
        )
    }
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return dedicatedService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    fetchPspData({commit}, hashid) {
        commit('loadingPspData')
        return dedicatedService.fetchPspData(hashid).then(response => {
            commit('setPspData', response.data.data)
        })
    },
    fetchByUserId({commit}, user_id) {
        commit('loading')
        let params = {
            'user_id': user_id
        }
        return dedicatedService.fetch(params).then(response => {
            commit('success', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        
        return dedicatedService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}